"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DataRequestRoute = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _dataRequestForm = _interopRequireDefault(require("./data-request-form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DataRequestRoute = function DataRequestRoute(_ref) {
  var location = _ref.location;
  var dispatch = (0, _reactRedux.useDispatch)();
  var socket = (0, _reactRedux.useSelector)(function (state) {
    return state.socket;
  });
  var queryParams = (0, _react.useMemo)(function () {
    return new URLSearchParams(location.search);
  }, [location.search]);
  var authCode = (0, _react.useMemo)(function () {
    return queryParams.get('code');
  }, [queryParams]);
  var locale = (0, _react.useMemo)(function () {
    return queryParams.get('lang') || 'de-DE';
  }, [queryParams]);
  var langCode = (0, _react.useMemo)(function () {
    return locale.substring(0, Math.max(2, locale.lastIndexOf('-')));
  }, [locale]);
  var isFirstUpdate = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (isFirstUpdate.current) {
      isFirstUpdate.current = false; // remove existing tokens to ensure a new token is requested

      _nicbaseSecurity.auth.removeAccessToken();
    }

    return function () {
      // remove token so the user can not accidently be authenticated when going to nic-place
      _nicbaseSecurity.auth.removeAccessToken();
    };
  }, []);

  var _useQuery = (0, _reactQuery.useQuery)(['data-request-auth', authCode], function () {
    if (!authCode) {
      throw new Error('No auth code.');
    }

    var url = "".concat(ENV.dataRequest.token_uri, "?grant_type=authorization_code&code=").concat(authCode, "&redirect_uri=").concat(ENV.dataRequest.redirect_uri);
    return fetch(url, {
      method: 'POST',
      headers: {
        Authorization: 'Basic dG91ci1kYXRhLXJlcXVlc3Q6Q2d4bVQwTUlwQU1nRVVHRUF1SGY='
      }
    }).then(function (response) {
      if (response.ok) {
        return response.json();
      }

      throw new Error(response.statusText);
    });
  }, {
    onSuccess: function onSuccess(_ref2) {
      var token = _ref2.access_token;

      _nicbaseSecurity.auth.setAccessToken(token);

      dispatch({
        type: _nicbaseReducers.AUTHENTICATE_USER_SUCCESS
      });
    },
    onError: function onError() {
      return dispatch({
        type: _nicbaseReducers.AUTHENTICATE_USER_ERROR
      });
    }
  }),
      isAuthenticating = _useQuery.isLoading,
      isAuthenticated = _useQuery.isSuccess;

  var _useTranslations = (0, _hooks.useTranslations)(langCode, {
    enabled: Boolean((socket === null || socket === void 0 ? void 0 : socket.connected) && isAuthenticated),
    onSuccess: function onSuccess(response) {
      dispatch((0, _nicbaseReducers.changeLocale)(locale));
      dispatch({
        type: _nicbaseReducers.FIND_ALL_TRANSLATIONS_SUCCESS,
        body: response
      });
    }
  }),
      isLoadingTranslations = _useTranslations.isLoading,
      areTranslationsLoaded = _useTranslations.isSuccess;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-gray-200 items-center flex flex-col w-full h-full"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    className: "h-8 w-auto m-3 self-start"
  }), (isAuthenticating || isLoadingTranslations) && /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null), isAuthenticated && areTranslationsLoaded && /*#__PURE__*/_react["default"].createElement(_dataRequestForm["default"], {
    portalId: parseInt(queryParams.get('portalId'), 10),
    tourId: queryParams.get('tourId')
  }));
};

exports.DataRequestRoute = DataRequestRoute;
DataRequestRoute.propTypes = {
  location: _propTypes["default"].shape({
    search: _propTypes["default"].string
  }).isRequired
};
var _default = DataRequestRoute;
exports["default"] = _default;